import { AchievementName } from '@helios/achievement';
import { useUser } from '../../../api/user/useUser';
import { TakeoverId } from '../../../hooks/useTakeover';
import { useTakeoverContext } from '../../_app/TakeoverProvider/TakeoverContext';
import { useTranslation, Takeover } from '@helios/frontend-core';


import { badgeDetailDescriptionMap } from './BadgeDetailTakeoverConfig';
import { BadgeDetailView } from './components/BadgeDetailView';

interface BadgeDetailTakeoverProps {
  isOpen: boolean;
  onDismiss: () => void;
  achievementName: AchievementName;
  achieved?: boolean;
  numberDone?: number;
  total?: number;
  dateEarned?: string;
}

const BadgeDetailTakeover = (props: BadgeDetailTakeoverProps) => {
  const { isOpen, onDismiss, achievementName, achieved, numberDone, total, dateEarned } = props;
  const { t } = useTranslation();
  const TRACKING_ID = `badge-detail-takeover-${achievementName}`;

  const { user } = useUser();
  const { openTakeover } = useTakeoverContext();
  const propertyId = user?.propertyIds?.[0];

  const handleLinkClick = () => {
    onDismiss();
  };

  const handleActionClick = (context: {
    user: any;
    propertyId?: string;
    openTakeover: (id: TakeoverId, props?: Record<string, any>) => void;
  }) => {
    const descConfig = badgeDetailDescriptionMap[achievementName];
    descConfig.onClick?.(context);
  };

  return (
    <Takeover
      isOpen={isOpen}
      onClose={onDismiss}
      trackingId={TRACKING_ID}
      heading={t(`badge.achievement.${achievementName}`)}
    >
      <BadgeDetailView
        achievementName={achievementName}
        achieved={achieved}
        numberDone={numberDone}
        total={total}
        dateEarned={dateEarned}
        trackingId={TRACKING_ID}
        onLinkClick={handleLinkClick}
        onActionClick={handleActionClick}
        user={user}
        propertyId={propertyId}
        openTakeover={openTakeover}
      />
    </Takeover>
  );
};

export default BadgeDetailTakeover;
